import React from 'react';
import { useNavigate } from 'react-router';

// ANTD
import { Button } from 'antd';

// STYLES
import './styles.scss';

function Error({ errorStatus, buttonErrorMsg, navigationUrl }: { errorStatus: string[], buttonErrorMsg: string, navigationUrl: string }) {

    const navigate = useNavigate();

    const navigateTo = (): void => {
        navigate(navigationUrl);
    };

    return (
        <div className="error-container">
            <div className="error-content">
                <h1>Error</h1>
                <div className="error-status-content">
                    {errorStatus.map((error: string, i: number) => (<p key={i}>{error}</p>))}
                </div>
                <Button size="large" shape="round" type="primary" onClick={() => navigateTo()}>{buttonErrorMsg}</Button>
            </div>
        </div>
    );
}

export default Error;